import api from '@/api'
// import storage from '@/utils/storage'
// import store from '@/store'
import request from '@/utils/request'

const state = () => ({})
const getters = {}
const mutations = {}
const actions = {
  GetCollectInfoTemplate(context, params) {
    return request({
      url: api.GetCollectInfoTemplate,
      method: 'GET',
      params,
    })
  },
  CustomerExtensionBatchSave(context, params) {
    return request({
      url: api.CustomerExtensionBatchSave,
      method: 'POST',
      data: params,
    })
  },
  SaveInfoCollection(context, params) {
    return request({
      url: api.SaveInfoCollection,
      method: 'POST',
      data: params,
    })
  },
  GetInfoCollection(context, params) {
    return request({
      url: api.GetInfoCollection,
      method: 'GET',
      params,
    })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
